// import { LoginAlertService } from '../services/loginalert.service';
// import { LoginUserService } from '../services/loginuser.service';
// import { StudentProfileService } from '../services/studentProfile.service';
// import { first } from 'rxjs/operators';
// import { Data } from '../../models/data';
// import { stringify } from '@angular/core/src/util';
// import { from } from 'rxjs';
// import { Directive, ViewContainerRef } from '@angular/core';
// import { Student } from '../../models/student';
// import { User } from '../../models/user';
import { FormBuilder, FormGroup, FormsModule, NgForm, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router,  NavigationExtras } from '@angular/router';
import { StudentGet } from '../../models/student-get';
import { UserProfile } from '../../models/user';
import { UserService } from '../../services/user.service';
import { LoginReq } from '../../models/user';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataSharingService } from '../../services/data-sharing.service';
import { CreateLogin } from '../../models/create-login';
import { Setting } from '../../models/settings';

@Component({
  selector: 'app-mhs-login',
  templateUrl: './mhs-login.component.html',
  styleUrls: ['./mhs-login.component.css']
})

export class MhsLoginComponent implements OnInit {
  login: LoginReq = new LoginReq();
  createLogin: CreateLogin = new CreateLogin();
  userProfile: UserProfile;
  disableSend = true;
  msg = '';
  submitted = false;
  loading = false;
  student: StudentGet = new StudentGet();
  systemStatus: Setting = new Setting();

  constructor(
    private _dataService: DataSharingService,
    private _router: Router,
    private _userService: UserService) {
    // Init container for request
      this.login = new LoginReq();
    }

  ngOnInit() {
    this.systemStatus.description = 'normal';
    this.getSetting('System', 'systemStatus');
    const createLogin = this._dataService.getCurrentUser();
    if (createLogin != null) {
      this.createLogin = createLogin.user;
      if (this.createLogin != null) {
        if (this.createLogin.roleId == this._userService.roleStudent) {
          this._router.navigate(['new-student-registration']);
        }
      }
    }
  }

  sendLogin(loginRequest: NgForm) {
    this.msg = '';
    this.submitted = true;
    if (loginRequest.dirty && loginRequest.valid) {
      // form is valid and dirty - send request'
      // this.submitted = true;
      this.loading = true;
      this._userService.login(this.login)
        .subscribe(
          res => this.sendLoginSuccessful(res),
          error => this.sendLoginFailed(error),
          () => {
            console.log('Login successful!');
          }
        )
      ;
    }
  }

  sendLoginSuccessful(res: any) {
    // this.loading = false;
    if (res.current_user.roleId != '1') {
      this.loading = false;
      this.msg = 'Staff must log in to Staff Portal'; // error.message;
      setTimeout(() => { this.msg = ''; }, 4000);
    } else {

      console.log(res.message);
      this.student = new StudentGet();
      this.student.email = res.current_user.email;
      this.student.firstName = res.current_user.firstName;
      this.student.middleName = res.current_user.middleName;
      this.student.lastName = res.current_user.lastName;
      this.student.studentLoginId = res.current_user.id;

      this.createLogin = new CreateLogin();
      this.createLogin.id = res.current_user.id;
      this.createLogin.email = res.current_user.email;
      this.createLogin.firstName = res.current_user.firstName;
      this.createLogin.middleName = res.current_user.middleName;
      this.createLogin.lastName = res.current_user.lastName;
      this.createLogin.password = this.login.password;
      this._dataService.setCurrentUser(this.createLogin);
      this._dataService.setAdminUser(null);
      this._dataService.setCurrentStudent(this.student);

      this._dataService.setAuthToken(res.auth_token);
      this._dataService.setRoleId(res.current_user.roleId);

      this.msg = 'Login successful! Now create or review your student information!';
      setTimeout(() => {
        this._router.navigate(['new-student-registration']);
      }, 4000);
    }
  }

  sendLoginFailed(error: any) {
    this.loading = false;
    console.log(error.message);
    this.msg = 'Login failed! Invalid email or password'; // error.message;
  }

  getSetting(type: string, name: string) {
    this._dataService.getSetting(type, name)
      .subscribe(
        res => this.getSettingSuccsess(res),
        error => this.settingFailure(error),
        () => console.log('Get ' + name + ' Complete!')
      );
  }

  getSettingSuccsess(result: any) {
    const setting = result[0] as Setting;
    this.settingSuccsess(setting);
  }
  settingSuccsess(result: any) {
    const setting = result as Setting;
    switch (setting.name) {
      case 'systemStatus':
        this.systemStatus = setting;
        break;
      default:
        break;
      }
  }
  settingFailure(error: any) {
    this.systemStatus.description = 'down';
    return 'error';
  }
}




// WEBPACK FOOTER //
// ./src/app/login/mhs-login/mhs-login.component.ts